export type AppLanguage = 'hr' | 'en';

/**
 * Language used for all frontend UI text.
 * Change to 'en' to switch the whole app to English.
 * (Text coming from the backend is not affected.)
 */
export const APP_LANGUAGE: AppLanguage = 'hr';
